import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  createCoupon,
  deleteCoupon,
  updateCoupon,
} from '../../../../store/membership/CouponReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const CouponForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.coupon)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createCoupon(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateCoupon(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteCoupon(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

CouponForm.displayName = 'CouponForm'

export default CouponForm
